import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router'

import { AppRoutes } from 'constants/appRoutes'
import { logout } from 'core/auth'

export const Header = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [region, setRegion] = useState<string>(window.env('REGION'))

  if (location.pathname === AppRoutes.login) {
    return null
  }

  const handleSelectRegion = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRegion(event.target.value)
    window.setRegion(event.target.value)
    window.location.reload()
  }

  const handleLogoutClick = () => {
    logout()
    navigate(AppRoutes.login)
  }

  return (
    <header className="app-header">
      <div className="header-left">
        <Link className="navbar-brand-custom" to={AppRoutes.root}>
          Home
        </Link>
        <div className="region-selector">
          <span>Region:</span>
          <select name="region" onChange={handleSelectRegion} value={region}>
            {Object.keys(window.env('REGIONS')).map((item, index) => (
              <option value={item} key={index}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>
      <button className="btn-logout" onClick={handleLogoutClick}>
        Logout
      </button>
    </header>
  )
}
